export interface Contact {
  nature?: string | null;
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  title?: string;
  source?: string;
  leadScore?: number;
  status?: string;
  productInterest?: string;
  city?: string;
  state?: string;
  notes?: string;
  customerType?: string;
  createdAt: string;
  account?: { id: string; name: string } | null;
}
export interface Account {
  id: string;
  name: string;
}
export interface Product {
  id: string;
  name: string;
}
export const SOURCES = ['Website', 'Referral', 'Social Media', 'Cold Call', 'Email Campaign', 'Trade Show', 'Partner', 'Other'];
export const STATUSES = ['lead', 'prospect', 'customer', 'inactive'];
